"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BalancePlanTable = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const compliance_pool_types_1 = require("../../compliance-pool-types");
const common_styled_components_1 = require("../../../common-styled-components");
const amountUtils_1 = require("../../../../util/amountUtils");
const react_1 = require("react");
const Modal_1 = require("../../common/Modal");
const useEdit_1 = __importDefault(require("../../../../hooks/useEdit"));
const theme_1 = require("../../../../theme");
const lodash_1 = require("lodash");
const YearContext_1 = require("../../../../contexts/YearContext");
const ExportCsvButton_1 = require("../ExportCsvButton");
const balancePlanTableColumns = (isInAdminTools) => [
    {
        key: "year",
        label: "Year",
    },
    {
        key: "balance",
        label: "+/- (tCO₂e)",
    },
    {
        key: "tools",
        label: "",
    },
].filter((c) => c.key !== "tools" || isInAdminTools === true);
const CellContent = ({ balancePlan, contentKey, isInAdminTools, removeBalancePlan, editBalancePlan, }) => {
    switch (contentKey) {
        case "balance":
            if (balancePlan.balance) {
                return ((0, jsx_runtime_1.jsxs)("div", { children: [balancePlan.balance > 0 ? "+" : "", (0, amountUtils_1.formatNumber)(balancePlan.balance)] }));
            }
            else {
                return (0, jsx_runtime_1.jsx)("div", {});
            }
        case "ship":
            return (0, jsx_runtime_1.jsx)("div", { children: balancePlan.ship.name });
        case "tools":
            return isInAdminTools && removeBalancePlan && editBalancePlan ? ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.SmallButton, { onClick: () => removeBalancePlan(balancePlan), children: "Remove" }), (0, jsx_runtime_1.jsx)(common_styled_components_1.SmallButton, { onClick: () => editBalancePlan(balancePlan), children: "Edit" })] })) : ((0, jsx_runtime_1.jsx)("div", {}));
        default:
            return (0, jsx_runtime_1.jsx)("div", { children: balancePlan[contentKey] });
    }
};
const BalancePlanTable = ({ balancePlans, metadata, isInAdminTools, shipId, refresh, }) => {
    const [modal, setModal] = (0, react_1.useState)({});
    const [editStatus, executeEdit] = (0, useEdit_1.default)("admin/balance_plan.json", refresh);
    const { selectedYear } = (0, YearContext_1.useYear)();
    const addBalancePlan = () => {
        setModal({
            type: "add",
            value: {
                ship_id: shipId,
                year: selectedYear,
            },
        });
    };
    const editBalancePlan = (balancePlan) => {
        setModal({
            type: "edit",
            value: {
                ship_id: balancePlan.ship.id ?? shipId ?? undefined,
                ...(0, lodash_1.pickBy)(balancePlan, (_, key) => key !== "ship"),
            },
        });
    };
    const removeBalancePlan = (balancePlan) => {
        setModal({
            type: "remove",
            value: balancePlan,
        });
    };
    const submit = (type, value) => {
        setModal({});
        if (type === "add") {
            if ((0, compliance_pool_types_1.isValidBalancePlanInput)(value)) {
                const data = {
                    id: null,
                    ...value,
                };
                executeEdit(data, "PUT");
            }
            else {
                alert("BalancePlan not valid");
            }
        }
        if (type === "edit") {
            if ((0, compliance_pool_types_1.isValidBalancePlanInput)(value)) {
                const data = {
                    id: value.id,
                    ...value,
                };
                executeEdit(data, "PUT");
            }
            else {
                alert("BalancePlan not valid");
            }
        }
        if (type === "remove") {
            if (value.id !== undefined) {
                const data = {
                    id: value.id,
                };
                executeEdit(data, "DELETE");
            }
        }
    };
    const sortedPlans = (0, lodash_1.sortBy)(balancePlans, "year");
    const columns = balancePlanTableColumns(isInAdminTools);
    const csvColumns = columns
        .filter((column) => column.key !== "tools")
        .map((column) => ({
        header: column.label,
        getValue: (balancePlan) => {
            switch (column.key) {
                case "balance":
                    return balancePlan.balance
                        ? `${balancePlan.balance > 0 ? "+" : ""}${(0, amountUtils_1.formatNumber)(balancePlan.balance) ?? ""}`
                        : "";
                case "ship":
                    return balancePlan.ship.name;
                default: {
                    const value = balancePlan[String(column.key)];
                    return typeof value === "string" || typeof value === "number"
                        ? value
                        : "";
                }
            }
        },
    }));
    return (metadata && ((0, jsx_runtime_1.jsxs)("div", { children: [modal.type && ((0, jsx_runtime_1.jsx)(Modal_1.Modal, { type: "balancePlan", isOpen: modal.type !== undefined, closeModal: () => setModal({}), modalType: modal.type, value: modal.value, submit: submit, shipId: shipId })), (0, jsx_runtime_1.jsxs)(common_styled_components_1.Row, { gap: 2, children: [isInAdminTools && ((0, jsx_runtime_1.jsx)(common_styled_components_1.SecondaryButton, { onClick: addBalancePlan, color: theme_1.theme.colors.blue, children: "+ Add balance plan" })), (0, jsx_runtime_1.jsx)(ExportCsvButton_1.ExportCsvButton, { rows: sortedPlans, columns: csvColumns, tableName: "balance-plans" })] }), (0, jsx_runtime_1.jsxs)(common_styled_components_1.Table, { children: [(0, jsx_runtime_1.jsx)("thead", { children: (0, jsx_runtime_1.jsx)("tr", { children: columns.map((c) => ((0, jsx_runtime_1.jsx)(common_styled_components_1.TH, { children: c.label }, c.key))) }) }), (0, jsx_runtime_1.jsx)("tbody", { children: sortedPlans.map((balancePlan) => {
                            return ((0, jsx_runtime_1.jsx)(common_styled_components_1.TR, { children: columns.map((c) => ((0, jsx_runtime_1.jsx)(common_styled_components_1.TD, { children: (0, jsx_runtime_1.jsx)(CellContent, { contentKey: c.key, balancePlan: balancePlan, isInAdminTools: isInAdminTools, editBalancePlan: isInAdminTools ? editBalancePlan : undefined, removeBalancePlan: isInAdminTools ? removeBalancePlan : undefined }) }, c.key))) }, balancePlan.id));
                        }) })] })] })));
};
exports.BalancePlanTable = BalancePlanTable;
